import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss';
import AppleStore from '../../images/apple_store.png';
import GooglePlay from '../../images/google_play.png';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_USER_DATA } from '../../redux/UserData';
import getCognitoAccessToken from '../../helpers/getCognitoAccessToken';
import LoaderButton from '../LoaderButton/LoaderButton';
const MobileAppBanner = ({ t, }) => {
  const newAppUser = useSelector((state) => state.userData.new_app_user)
  const classes = useStyles({ newAppUser, })
  const [showBanner, setShowBanner] = useState(true)
  const isMobile = window.innerWidth < 500

  const dispatch = useDispatch()
  useEffect(() => {
    getCognitoAccessToken().then((token) => {
      if (token.length) {
        dispatch(FETCH_USER_DATA())
      }
    })
  }, [dispatch])
  const userEmail = useSelector((state) => state.userData.email)
  useEffect(() => {

    if (userEmail) {
      localStorage.setItem('dealer_email', userEmail)
    }
  }, [userEmail])


  if (!showBanner) {
    return <></>
  }

  return (
    <div className={classes.wrapper} style={{ display: newAppUser ? 'block' : 'none', }}>
      <div className={classes.container}>
          <div className={classes.closeButton}>
          {!newAppUser && (
            <i onClick={() => setShowBanner(false)} className="material-icons modal-close-button">close</i>
          )}
        </div>
        <div className={classes.text}>
          {t('download_app')}
        </div>

        {isMobile && (
          <div className={classes.buttonContainer}>
            <a href="itms-apps://apps.apple.com/tr/app/times-tables-lets-learn/id6469692534?l=tr">
              <img src={AppleStore} width={149} />
          </a>
          <a href="market://details?id=com.estigroup.dealerapp">
            <img src={GooglePlay} width={162} />
            </a>
          </div>
        )}

        {!isMobile && (
          <div className={classes.buttonContainer}>
            <LoaderButton
              label={t('open_app')}
              onClick={() => {
                window.location.href = 'https://dealers.estigroup.de'
              }}
            />
          </div>
        )}
      </div>
      <div className={classes.gradient} />
    </div>
  )
}

const useStyles = createUseStyles({
  wrapper: {
    position: 'absolute',
    zIndex: 5,
  },
  gradient: {
    background: 'linear-gradient(to bottom, #3682ce, transparent)',
    height: '95vh',
    zIndex: 5,
  },
  container: {
    width: '100vw',
    background: '#3682ce',
    color: 'white',
    textAlign: 'center',
    zIndex: 5,
  },
  buttonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginTop: '20px',
    display: 'flex',
  },

  closeButton: {
    display: 'flex',
    padding: 10,
    justifyContent: 'flex-end',
    marginRight: 5,
  },
  text: {
    margin: '0 20px',
  },
  '@media(min-width: 500px)': {
    wrapper: {
      display: 'none',
    },
  },
});


MobileAppBanner.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withScopedTranslations('mobile_app_banner')(MobileAppBanner)
